/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_t3 as t3,
} from "../../runtime/index.jsx";
export function Componente_i3_105_51(e) {
  let t = (0, ReactCompiler.c)(10),
    { titulo: n, valor: r, alerta: i } = e,
    a = i !== void 0 && i,
    o;
  t[0] === n
    ? (o = t[1])
    : ((o = <p className={`text-xs text-(--text)`} children={n} />),
      (t[0] = n),
      (t[1] = o));
  let s = `text-2xl font-semibold ${a && r ? `text-(--warning-texto)` : `text-(--text-h)`}`,
    c;
  t[2] === r ? (c = t[3]) : ((c = t3(r)), (t[2] = r), (t[3] = c));
  let l;
  t[4] !== s || t[5] !== c
    ? ((l = <p className={s} children={c} />),
      (t[4] = s),
      (t[5] = c),
      (t[6] = l))
    : (l = t[6]);
  let u;
  return (
    t[7] !== o || t[8] !== l
      ? ((u = <div className={Bo} children={[o, l]} />),
        (t[7] = o),
        (t[8] = l),
        (t[9] = u))
      : (u = t[9]),
    u
  );
}
